export default __webpack_public_path__ + "static/media/home-2.0ae954f6.png";